
  if (!customElements.get('hg-crosssell-quantity-total')) {
    customElements.define('hg-crosssell-quantity-total', class extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info') || document;
        this.refresh = () => {
          if (this.queued) return;
          this.queued = true;
          queueMicrotask(() => { this.queued = false; if (this.isConnected) this.update(); });
        };
        this.onInput = (event) => {
          const target = event.target;
          if (target.matches?.('[data-hg-independent-quantity]') && this.bundle?.contains(target)) {
            const checkbox = target.closest('[data-hg-product-id]')?.querySelector('input[name="bundles"]');
            if (checkbox && !checkbox.disabled) checkbox.checked = true;
          }
          if (this.dataset.jewelry === 'true' && target.matches?.('select') && this.bundle?.contains(target)) {
            const card = target.closest('[data-hg-product-id]');
            const option = target.selectedOptions?.[0];
            const link = card?.querySelector('.horizontal-product__title a');
            if (link && option?.dataset.hgUrl) link.href = option.dataset.hgUrl;
            const image = card?.querySelector('img');
            if (image && option?.dataset.imgAlt) image.alt = option.dataset.imgAlt;
          }
          if (this.scope.contains(target) || target.form?.id === this.dataset.formId) this.refresh();
        };
        this.beforeSubmit = (event) => {
          const button = event.target.closest?.('button[type="submit"]');
          if (event.type === 'submit' ? event.target.id !== this.dataset.formId : button?.form?.id !== this.dataset.formId && button?.getAttribute('form') !== this.dataset.formId) return;
          this.apply(false);
          this.syncExpress();
        };
        this.onCart = (event) => {
          const ids = new Set((event.cart?.items || []).map(item => String(item.product_id)));
          if (this.dataset.jewelry === 'true') {
            for (const input of this.bundle?.querySelectorAll('input[name="bundles"]') || []) input.checked = false;
            this.update();
            this.loadRecommendations();
            return;
          }
          for (const card of this.bundle?.querySelectorAll('[data-hg-product-id]') || []) {
            if (!ids.has(card.dataset.hgProductId)) continue;
            card.hidden = true;
            const input = card.querySelector('input[name="bundles"]');
            if (input) { input.checked = false; input.disabled = true; }
          }
          this.update();
          this.loadRecommendations();
        };
        document.addEventListener('input', this.onInput);
        document.addEventListener('change', this.onInput);
        document.addEventListener('submit', this.beforeSubmit, true);
        document.addEventListener('click', this.beforeSubmit, true);
        window.addEventListener('pageshow', this.refresh);
        this.scope.addEventListener('recommendations:loaded', this.refresh, true);
        this.scope.addEventListener('bundle:change', this.refresh, true);
        this.bindNative = () => {
          if (!this.isConnected || this.unsubscribe || !window.theme?.pubsub) return;
          this.unsubscribe = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.onCart);
          this.unsubscribeVariant = window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, this.refresh);
        };
        this.bindNative();
        customElements.whenDefined('product-info').then(this.bindNative);
        this.update();
      }
      disconnectedCallback() {
        this.request?.abort();
        this.unsubscribe?.();
        this.unsubscribeVariant?.();
        this.unsubscribe = null;
        document.removeEventListener('input', this.onInput);
        document.removeEventListener('change', this.onInput);
        document.removeEventListener('submit', this.beforeSubmit, true);
        document.removeEventListener('click', this.beforeSubmit, true);
        window.removeEventListener('pageshow', this.refresh);
        this.scope.removeEventListener('recommendations:loaded', this.refresh, true);
        this.scope.removeEventListener('bundle:change', this.refresh, true);
      }
      get bundle() { return document.getElementById(this.dataset.bundleId); }
      get form() { return document.getElementById(this.dataset.formId); }
      quantity() {
        const input = this.scope.querySelector('.hg-calendar-custom:not([hidden]) .quantity__input')
          || document.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]`)
          || this.form?.querySelector('input[name="quantity"]');
        const value = Number(input?.value);
        return Number.isSafeInteger(value) && value > 0 ? value : 1;
      }
      apply(notify) {
        const quantity = this.quantity();
        for (const input of this.bundle?.querySelectorAll('input[name="bundles"]') || []) {
          const card = input.closest('[data-hg-product-id]');
          const select = card?.querySelector('select');
          const rules = select?.selectedOptions?.[0] || input;
          const minimum = Math.max(1, Number(rules.dataset.hgMin) || 1);
          const maximum = Math.max(0, Number(rules.dataset.hgMax ?? 10));
          const step = Math.max(1, Number(rules.dataset.hgStep) || 1);
          const firstValid = Math.ceil(minimum / step) * step;
          const independent = card?.querySelector('[data-hg-independent-quantity]');
          const requested = independent ? Number(independent.value) || minimum : quantity;
          const next = Math.max(firstValid, Math.floor(Math.min(requested, maximum) / step) * step);
          if (independent) {
            independent.min = String(firstValid);
            independent.max = String(maximum);
            independent.step = String(step);
            independent.disabled = maximum < firstValid || card.hidden;
            if (independent.value !== String(next)) independent.value = String(next);
          }
          const disabled = card?.hidden || rules.disabled || maximum < firstValid || next > maximum || next % step !== 0;
          input.disabled = Boolean(disabled);
          if (disabled) input.checked = false;
          const changed = input.dataset.min !== String(next);
          input.dataset.min = String(next);
          input.dataset.hgMax = String(maximum);
          if (changed && notify && input.checked) input.dispatchEvent(new Event('change', { bubbles: true }));
          const mult = card?.querySelector('[data-hg-xs-mult]');
          if (mult) {
            mult.hidden = !input.checked || next <= 1;
            mult.textContent = next > 1 ? `× ${next}` : '';
          }
        }
      }
      syncExpress() {
        if (this.dataset.express !== 'true' || !this.form) return;
        const selected = [...(this.bundle?.querySelectorAll('input[name="bundles"]:checked:not(:disabled)') || [])];
        const values = selected.flatMap((input, index) => [
          [`shopify-additional-items[${index + 1}][id]`, input.value],
          [`shopify-additional-items[${index + 1}][quantity]`, input.dataset.min || '1']
        ]);
        const fields = [...this.form.querySelectorAll('[data-hg-express-item]')];
        values.forEach(([name, value], index) => {
          let field = fields[index];
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.setAttribute('data-hg-express-item', '');
            this.form.append(field);
          }
          if (field.name !== name) field.name = name;
          if (field.value !== value) field.value = value;
        });
        fields.slice(values.length).forEach(field => field.remove());
      }
      update() {
        if (!this.isConnected) return;
        this.apply(true);
        this.syncExpress();
        const details = this.bundle?.querySelector('details');
        if (details) details.hidden = ![...details.querySelectorAll('[data-hg-product-id]')].some(card => !card.hidden);
        const selected = Boolean(this.bundle?.querySelector('input[name="bundles"]:checked:not(:disabled)'));
        for (const button of document.querySelectorAll(`button[type="submit"][form="${this.dataset.formId}"]`)) {
          if (button.disabled || button.hasAttribute('data-unavailable') || button.hasAttribute('unavailable')) continue;
          const label = button.querySelector('.btn-text > span');
          if (!label) continue;
          const text = selected ? this.dataset.selectedLabel : this.dataset.defaultLabel;
          label.textContent = text;
          button.setAttribute('aria-label', text);
        }
      }
      async loadRecommendations() {
        this.request?.abort();
        const request = this.request = new AbortController();
        const existing = this.bundle?.querySelector('product-recommendations');
        const url = new URL(existing?.dataset.url || this.dataset.productUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const variantId = this.form?.querySelector('[name="id"]')?.value;
        if (variantId) url.searchParams.set('variant', variantId);
        try {
          const response = await fetch(url, { signal: request.signal, cache: 'no-store' });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected || request !== this.request) return;
          const source = html.getElementById(this.dataset.bundleId)?.querySelector('.hg-crosssell');
          const target = this.bundle?.querySelector('.hg-crosssell');
          if (!source || !target) return;
          const open = target.querySelector('details')?.open;
          target.innerHTML = source.innerHTML;
          target.hidden = !source.querySelector('details');
          const details = target.querySelector('details');
          if (details && open !== undefined) details.open = open;
          this.update();
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Product recommendations could not be refreshed.');
        }
      }
    });
  }
